// extracted by mini-css-extract-plugin
export default {"root":"TwDDM","item":"Ite2h"};